export const checkIfErrors = (propName, errors) => errors === null || errors === void 0 ? void 0 : errors.hasOwnProperty(propName);
export const helperText = (propName, errors) => checkIfErrors(propName, errors) && errors[propName].message;
